// @ts-nocheck
/* eslint-disable */
import { addListener, makeEvent } from "~/lib/signals";
import { _ } from "~/i18n";

Mapy.StateSwitch = class {
	constructor() {
		this._states = [
			{ title: _("stateSwitch.search"), content: "search", className: "search", id: "s", switcher: null, accesskey:4 },
			{ title: _("stateSwitch.route"), content: "route", className: "route", id: "r", switcher: null },
			{ dom: Mapy.getComponent("mymaps").getButton(), content: "mymaps" },
			{ dom: Mapy.getComponent("profile").getButton(), content: "profile" }
		];

		this._dom = {};
		this._activeSwitcher = null;
		this._parentNode = Mapy.getComponent("layout").getBar();
		this._build(this._parentNode);

		addListener(this, "distacemeter-activated", () => {
			this._duAct();
		});
		addListener(this, "distacemeter-deactivated", () => {
			this._duDeact();
		});
		addListener(this, "usermarks-activated", () => {
			this._duAct();
		});
		addListener(this, "usermarks-deactivated", () => {
			this._duDeact();
		});
		addListener(this, "gpx-activated", () => {
			this._duAct();
		});
		addListener(this, "gpx-deactivated", () => {
			this._duDeact();
		});
		addListener(this, "userprofile-activated", () => {
			this._duAct();
		});
		addListener(this, "userprofile-deactivated", () => {
			this._duDeact();
		});
	}

	/* na vyzadani vrati nazev stavu ktery je ve chvili volani aktivni a zohledni i stav switcheru */
	getStateName() {
		var stateName = "";

		for(var i = 0; i < this._states.length; i++) {
			if(this._states[i].dom.classList.contains("active")) {
				var stateName = this._states[i].title;
				if(this._states[i].switcher) {
					var switcherStateName =  this._states[i].switcher.getStateName();
				}
				return switcherStateName || stateName;
			}

		}
		return "";
	}

	getState(id) {
		for (var i = 0; i < this._states.length; i++) {
			if (this._states[i].id == id) {
				return this._states[i];
			}
		}
		return null;
	}

	setState(content) {
		var activeSwitcher = null;
		for (var i = 0, len = this._states.length; i < len; i++) {
			var state = this._states[i];
			state.dom.classList[content === Mapy.getComponent(state.content) ? "add" : "remove"]("active");

			if (!state.switcher) { continue; }

			/* ma switcher, zkusime ho */
			var switcher = state.switcher;

			var node = switcher.getContainer();
			if (switcher.setState(content)) { /* chytil se */
				var con = Mapy.getComponent("layout").getBody();
				state.dom.classList.add("active");
				con.insertBefore(node, con.firstChild);
				activeSwitcher = switcher;
			} else { /* ne, tento switcher to neni */
				node.remove();
			}
		}

		var change = this._activeSwitcher != activeSwitcher;

		this._activeSwitcher = activeSwitcher;

		if (change) {
			makeEvent(this._activeSwitcher ? "backpack-activate" : "backpack-deactivate", this);
		}
	}

	handleEvent(e) {
		if (e.currentTarget.classList.contains("active") && Mapy.active.length > 1) {
			while (Mapy.active.length > 1) {
				Mapy.active[0].deactivate();
			}
			Mapy.getComponent("history").save();
			return;
		}

		for (var i = 0; i < this._states.length; i++) {
			var state = this._states[i];

			if (state.dom.contains(e.target)) {
				this._activateState(state);
			}
		}
	}

	_build(parent) {
		for (var i = 0, len = this._states.length; i < len; i++) {
			var state = this._states[i];
			var item = null;
			if (state.dom) {
				item = state.dom;
			}
			else {
				item = Mapy.Util.node("button", { type: "button", innerHTML: "<span>" + state.title + "</span>", className: "icon " + state.className });
				item.setAttribute("data-log-text", "stateswitch-" + state.content);
				if ("accesskey" in state) { item.accessKey = state.accesskey; }
				this._states[i].dom = item;
			}

			item.addEventListener("click", this, false);
			parent.appendChild(item);
		}
	}

	showSwitcher() {
		if (this._activeSwitcher) {
			this._activeSwitcher.getContainer().style.display = "";
		}
	}

	hideSwitcher() {
		if (this._activeSwitcher) {
			this._activeSwitcher.getContainer().style.display = "none";
		}
	}

	_activateState(state) {
		var content = state.switcher ? state.switcher.getActiveContent() : Mapy.getComponent(state.content);
		content.activate(!state.switcher);
		Mapy.getComponent("history").save();
	}

	isActive() {
		return !!this._activeSwitcher;
	}

	_duAct() {
		this._parentNode.classList.add("du-act");
	}

	_duDeact() {
		this._parentNode.classList.remove("du-act");
	}
};
